import { Card, Button, Dropdown, Badge } from "react-bootstrap"
import { Link, useNavigate } from "react-router-dom"
import {
  Icon,
  CustomDropdownToggle,
  CustomDropdownMenu,
  LinkList,
} from "../../../components"
import Layout from "../../../layout/default"
import Block from "../../../components/Block/Block"
import DataTable from "../../../components/DataTable/DataTable.js"

import React, { useEffect, useState } from "react"
import notificationSettingsService from "../services/notification_settingsService"

const Notification_settingsList = () => {
  const navigate = useNavigate()
  const [notification_settingsData, setNotification_settings] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    fetchNotification_settingsList()
  }, [])

  const fetchNotification_settingsList = async () => {
    try {
      const response =
        await notificationSettingsService.getNotification_settingsList()
      setNotification_settings(response)
      setLoading(false)
    } catch (error) {
      console.log("Error fetching notification_settings list:", error)
      setLoading(false)
    }
  }

  const handleDeleteNotification_settings = async (notification_settingsId) => {
    try {
      setLoading(true)
      await notificationSettingsService.deleteNotification_settings(
        notification_settingsId
      )
      const data = notification_settingsData.filter(
        (rows) => rows.id != notification_settingsId
      )
      setNotification_settings(data)
      setLoading(false)
    } catch (error) {
      console.log("Error deleting notification_settings:", error)
      setLoading(false)
    }
  }

  const handleCreateNotification_settings = () => {
    navigate("/notification_settings/new")
  }

  const notification_settingsColumns = [
    {
      name: "id",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "número de teléfono",
      selector: (row) => row.phone_number,
      sortable: true,
    },
    {
      name: "cliente potencial",
      selector: (row) => {
        if (row.potencial_lead) {
          return <Badge bg="success">Yes</Badge>
        } else {
          return <Badge bg="warning">No</Badge>
        }
      },
      sortable: true,
    },
    {
      name: "resumen mensual",
      selector: (row) => {
        if (row.monthly_resume) {
          return <Badge bg="success">Yes</Badge>
        } else {
          return <Badge bg="warning">No</Badge>
        }
      },
      sortable: true,
    },
    {
      name: "nueva factura",
      selector: (row) => {
        if (row.new_bill) {
          return <Badge bg="success">Yes</Badge>
        } else {
          return <Badge bg="warning">No</Badge>
        }
      },
      sortable: true,
    },

    {
      name: "enviar email",
      selector: (row) => {
        if (row.send_email) {
          return <Badge bg="success">Yes</Badge>
        } else {
          return <Badge bg="warning">No</Badge>
        }
      },
      sortable: true,
    },
    {
      name: "enviar sms",
      selector: (row) => {
        if (row.send_sms) {
          return <Badge bg="success">Yes</Badge>
        } else {
          return <Badge bg="warning">No</Badge>
        }
      },
      sortable: true,
    },
    {
      name: "accciones",
      cell: (row) => (
        <div className="text-end w-100">
          <Dropdown>
            <Dropdown.Toggle
              size="sm"
              as={CustomDropdownToggle}
              className="btn btn-sm btn-icon btn-zoom me-n1"
            >
              <Icon name="more-v" />
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="dropdown-menu-sm"
              as={CustomDropdownMenu}
              align="end"
            >
              <div className="dropdown-content py-1">
                <LinkList className="link-list-hover-bg-primary link-list-md">
                  <Link
                    to={`/notification_settings/edit/${row.id}`}
                    className="dropdown-item"
                  >
                    <Icon name="edit" />
                    <span>Editar</span>
                  </Link>
                  <button
                    className="dropdown-item"
                    onClick={() => handleDeleteNotification_settings(row.id)}
                  >
                    <Icon name="trash" />
                    <span>Eliminar</span>
                  </button>
                </LinkList>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
      sortable: false,
    },
  ]

  return (
    <Layout title="Lista de ajuste de las notificaciones" content="container">
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Lista de ajustes de las notificaciones</Block.Title>
            <nav>
              <ol className="breadcrumb breadcrumb-arrow mb-0">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Ajuste de notificaciones
                </li>
              </ol>
            </nav>
          </Block.HeadContent>
          <Block.HeadContent>
            <ul className="d-flex">
              <li>
                <Button
                  className="d-md-none"
                  size="md"
                  variant="primary"
                  onClick={handleCreateNotification_settings}
                >
                  <Icon name="plus" />
                  <span>Añadir</span>
                </Button>
              </li>
              <li>
                <Button
                  className="d-none d-md-inline-flex"
                  variant="primary"
                  onClick={handleCreateNotification_settings}
                >
                  <Icon name="plus" />
                  <span>Añadir ajustes para las notificaciones</span>
                </Button>
              </li>
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Card>
          {!loading ? (
            <DataTable
              tableClassName="data-table-head-light table-responsive"
              data={notification_settingsData}
              columns={notification_settingsColumns}
              expandableRows
              actions
            />
          ) : (
            <p>Loading...</p>
          )}
        </Card>
      </Block>
    </Layout>
  )
}

export default Notification_settingsList
